// TODO : lint warning 처리용, 추후 래핑해서 개발 환경에서만 동작하게 한다던가 하는 작업을 추가할 예정
export const logger = console;
